import {View} from "./View"
export const AccountDetailsLink =  ()=> {
    return(
        <View  />
    )
}